<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Free Trial
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search schools"
            single-line
            hide-details
            @input="onSearch"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="schools"
          :loading="loading"
          item-key="id"
          :page.sync="page"
          :items-per-page.sync="itemsPerPage"
          :server-items-length="totalItems"
          :footer-props="{
            'items-per-page-options': [5, 10, 25, 50]
          }"
          class="elevation-1"
          @update:page="onPageChange"
          @update:items-per-page="onItemsPerPageChange"
        >
          <template v-slot:item.free_trial="{ item }">
            <v-switch
              :input-value="item.free_trial"
              @change="val => onToggle(item, val)"
              :loading="item.__saving === true"
              inset
              color="success"
            ></v-switch>
          </template>
          <template v-slot:item.free_trial_status="{ item }">
            <v-chip x-small :color="statusColor(item.free_trial_status)" dark>
              {{ statusLabel(item.free_trial_status) }}
            </v-chip>
          </template>
          <template v-slot:item.free_trial_ends_at="{ item }">
            <small>{{ formatDate(item.free_trial_ends_at) }}</small>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import FreeTrialService from '@/services/FreeTrialService.js'

export default {
  data() {
    return {
      loading: false,
      schools: [],
      search: '',
      page: 1,
      itemsPerPage: 10,
      totalItems: 0,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Phone', value: 'email' },
        { text: 'Free Trial', value: 'free_trial', sortable: false },
        { text: 'Status', value: 'free_trial_status', sortable: false },
        { text: 'Ends At', value: 'free_trial_ends_at', sortable: false },
      ],
    };
  },
  mounted() {
    this.fetchSchools();
  },
  methods: {
    async fetchSchools() {
      this.loading = true;
      try {
        const response = await FreeTrialService.getSchoolsFreeTrial(this.page, this.itemsPerPage);
        if (response && response.success) {
          this.schools = (response.data || []).map(s => ({ ...s, __saving: false }));
          this.totalItems = response.total || 0;
        } else {
          this.$notify({ title: 'Error', text: 'Failed to load schools', type: 'error' });
        }
      } catch (error) {
        this.$notify({ title: 'Error', text: 'Failed to load schools', type: 'error' });
      } finally {
        this.loading = false;
      }
    },
    onPageChange(page) {
      this.page = page;
      this.fetchSchools();
    },
    onItemsPerPageChange(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.page = 1; // Reset to first page when changing items per page
      this.fetchSchools();
    },
    onSearch() {
      // For now, search is client-side. In future, could implement server-side search
      // Reset to first page when searching
      this.page = 1;
      // Note: Search is still client-side, but pagination works
    },
    async onToggle(item, value) {
      item.__saving = true;
      try {
        const response = await FreeTrialService.setSchoolFreeTrial(item.id, !!value);
        if (response && response.success) {
          item.free_trial = !!value;
          item.free_trial_started_at = response.data ? response.data.free_trial_started_at : item.free_trial_started_at;
          item.free_trial_ends_at = response.data ? response.data.free_trial_ends_at : item.free_trial_ends_at;
          item.free_trial_status = !!value ? 'active' : 'inactive';
          this.$notify({ title: 'Saved', text: 'Updated successfully', type: 'success' });
        } else {
          throw new Error('Save failed');
        }
      } catch (error) {
        item.free_trial = !value; // revert UI
        this.$notify({ title: 'Error', text: 'Failed to update', type: 'error' });
      } finally {
        item.__saving = false;
      }
    },
    statusLabel(status) {
      if (status === 'active') return 'Active';
      if (status === 'expired') return 'Expired';
      return 'Inactive';
    },
    statusColor(status) {
      if (status === 'active') return 'green';
      if (status === 'expired') return 'orange';
      return 'grey';
    },
    formatDate(value) {
      if (!value) return '-';
      return this.$moment ? this.$moment(value).format('YYYY-MM-DD HH:mm') : value;
    },
  },
};
</script>

<style scoped>
</style>


